import { ExternalIdp } from 'features/integrations/types'
import { useEffect, useState } from 'react'
import useOAuth from '../useOAuth'
import { ProviderType } from 'features/connections/types'

function useSnowflakeOAuth(externalIdp?: ExternalIdp) {
  const { oauthState, isOAuthLoading, resetOAuthStatus, startOAuth: openConsent, oauthError } = useOAuth()
  const [showRoleDialog, setShowRoleDialog] = useState<boolean>(false)
  const [selectedRole, setSelectedRole] = useState<string | undefined>('')

  useEffect(() => {
    return () => {
      resetOAuthStatus()
    }
  }, [resetOAuthStatus])

  const handleOAuth = () => {
    setShowRoleDialog(true)
  }

  const startOAuth = async (role?: string) => {
    setShowRoleDialog(false)
    setSelectedRole(role)
    const params: { external_idp_id: string; role?: string } = {
      external_idp_id: externalIdp?.id as string
    }
    if (role) {
      params.role = role
    }
    openConsent({
      provider: ProviderType.SNOWFLAKE,
      params
    })
  }

  return {
    showRoleDialog,
    setShowRoleDialog,
    selectedRole,
    handleOAuth,
    startOAuth,
    oauthState,
    isOAuthLoading,
    resetOAuthStatus,
    oauthError
  }
}

export default useSnowflakeOAuth
